// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
export default React.forwardRef(function ArrowsSync(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "ArrowsSync" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { d: "M7.5 1.5L0.75 6.75L7.5 12V8.25H17.25V11.25H20.25V6.75C20.25 5.92157 19.5784 5.25 18.75 5.25H7.5V1.5Z", fill: "currentColor" }),
            React.createElement("path", { d: "M15.75 22.5L22.5 17.25L15.75 12L15.75 15.75H6V12.75H3L3 17.25C3 18.0784 3.67157 18.75 4.5 18.75H15.75V22.5Z", fill: "currentColor" }))));
});
//# sourceMappingURL=ArrowsSync.js.map